import React from 'react'
import { Button } from '@/race-tracker/components/ui/button'
import { AlertTriangle } from 'lucide-react'

export default function BplQueryError({ label, error, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center h-64 gap-4 p-6 text-center">
      <AlertTriangle className="w-8 h-8 text-destructive" />
      <p className="text-sm font-medium text-destructive">Failed to load {label}</p>
      <p className="text-xs text-muted-foreground max-w-md">
        {error?.message || 'An unexpected error occurred.'}
      </p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={() => onRetry()}>
          Retry
        </Button>
      ) : null}
    </div>
  )
}
